module.exports = __webpack_public_path__ + "img/modular-coding-dark.370505ae.svg";